import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaUsers, FaSave, FaThumbsUp } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import Alert from '../../../components/Alert';
import { toast } from 'react-toastify';
import '../../../css/financeiro-parcela-pagar.css';

export default function EventoVincularParticipanteOperador({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const history = useHistory();
    const [participantes, setParticipantes] = useState([]);
    const [operadores, setOperadores] = useState([]);
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [operadoresMarcados, setOperadoresMarcados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    let { state } = useLocation();
    var nomeEvento = state?.nomeEvento ?? null;

    const toggleSelect = (opId) => {
        setSelectedIds(prev => {
            const n = new Set(prev);
            n.has(opId) ? n.delete(opId) : n.add(opId);
            setOperadoresMarcados([...n]);
            return n;
        });
    };

    const total = operadores.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = operadores.slice((page - 1) * pageSize, page * pageSize);

    // marca/desmarca a LISTA INTEIRA, não só a página visível — o checkbox do cabeçalho
    // sugere "todos" e antes pegava só os 15 da página atual
    const todosMarcados = operadores.length > 0 && selectedIds.size === operadores.length;

    const toggleAll = () => {
        const newSet = todosMarcados ? new Set() : new Set(operadores.map(r => r.id));
        setSelectedIds(newSet);
        setOperadoresMarcados([...newSet]);
    };

    const buscar = () => {
        //busca lista de participantes do evento por status
        api({
            method: 'get',
            action: '/evento/participantesPorStatus/' + id,
            token: token,
        })
            .then(response => {
                setParticipantes(response.data.data);
            }).catch(err => {
                //console.log(err)
            });

        //busca lista de operadores ativos
        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                ...{
                    tipoCadastro: "pessoa",
                    // relações que esta tela lê (o endpoint só carrega o que for declarado)
                    include: 'enderecomunicipio,evento,cargo',
                    situacaoRegistro: "ativo",
                    eventoOperador: id,
                    quantidadeparticipantesvinculados: true,
                    perfil: [9, 8],
                    orderBy: {
                        cargo: 'asc'
                    }
                }
            }
        })
            .then(response => {
                setOperadores(response.data.data);
            }).catch(err => {
                //console.log(err)
            });
    };

    const salvar = () => {
        if (isSubmitting) {
            return;
        }

        // as duas travas que faltavam: sem operador o backend dividia por zero,
        // sem status marcado o salvar não fazia nada e ainda assim dizia "salvo"
        if (operadoresMarcados.length === 0) {
            toast.error('Selecione ao menos um operador');
            return;
        }
        if (!participantes.some(participante => participante.marcado === "sim")) {
            toast.error('Selecione ao menos um status de participante');
            return;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/evento/vincularParticipantesOperadores/' + id,
            token: token,
            data: {
                participantes: participantes,
                operadores: operadoresMarcados
            }
        })
            .then(function (response) {
                const resultado = response.data?.data ?? {};
                const vinculados = resultado.vinculados ?? 0;
                const mantidos = resultado.mantidos ?? 0;
                const ignorados = resultado.ignorados ?? 0;
                toast.success(
                    `${vinculados} participante(s) vinculado(s).` +
                    (mantidos > 0 ? ` ${mantidos} já tinha(m) operador e foi(ram) mantido(s).` : '')
                );
                // sem isso o gestor que perdeu a corrida para outro gestor via "0 vinculado(s)"
                // sem nenhuma pista de que a seleção dele não valeu
                if (ignorados > 0) {
                    toast.warning(`${ignorados} participante(s) receberam operador em paralelo e não foram vinculados à sua seleção.`);
                }
                history.push("/eventoParticipante/" + id);
            })
            .catch(function (error) {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };//salvar

    useEffect(() => { //onload
        buscar();
    },
    // eslint-disable-next-line
    []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Vincular Participantes aos Operadores</h1>
                        {nomeEvento && <p className="fin-pp__subtitle">Evento: {nomeEvento}</p>}
                    </div>
                </div>

                <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    {/* Status cards dos participantes */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                        {participantes.map(function (participante, index) {
                            const marcado = participante.marcado ?? "nao";
                            return (
                                <div key={participante.id ?? index} className="fin-pp__card" style={{ padding: 16, minWidth: 220, flex: '1 1 220px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: 'var(--fin-tx)' }}>
                                            <input
                                                type="checkbox"
                                                value={marcado}
                                                checked={marcado === "sim"}
                                                onChange={() => {
                                                    setParticipantes(participantes.map((item, indexItem) => (
                                                        indexItem === index
                                                            ? { ...item, marcado: (item.marcado ?? "nao") === "nao" ? "sim" : "nao" }
                                                            : { ...item, marcado: item.marcado ?? "nao" }
                                                    )));
                                                }}
                                            />
                                            {participante.nomeSituacao}
                                        </label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--fin-mt)' }} title="Sem operador">
                                            <span>{participante.quantidadeTotal}</span>
                                            <FaUsers size={16} />
                                        </div>
                                    </div>
                                    {/* o card conta quem ainda não tem operador; o distribuído fica visível ao lado
                                        para não parecer que o status inteiro está pendente */}
                                    <div className="fin-pp__cell-muted" style={{ marginTop: 8, fontSize: 12 }}>
                                        {participante.quantidadeTotal} sem operador de {participante.quantidadeSituacao ?? participante.quantidadeTotal} no status
                                        {(participante.quantidadeDistribuidos ?? 0) > 0
                                            ? ` (${participante.quantidadeDistribuidos} já distribuído(s))`
                                            : ''}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Tabela de operadores */}
                    <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ padding: '12px 16px' }}>
                            <h2 className="fin-pp__cphead-title">Operadores</h2>
                        </div>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 40 }}>
                                            <input
                                                type="checkbox"
                                                title="Marcar todos os operadores da lista"
                                                checked={todosMarcados}
                                                onChange={toggleAll}
                                            />
                                        </th>
                                        <th style={{ width: 90 }}>Código</th>
                                        <th style={{ width: 150 }}>Cargo</th>
                                        <th>Nome</th>
                                        <th>Outros eventos<br /><small className="fin-pp__cell-muted">total / pendentes</small></th>
                                        <th>Este evento<br /><small className="fin-pp__cell-muted">total</small></th>
                                        <th>Pendentes</th>
                                        <th>Concluídos</th>
                                        <th style={{ width: 100 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginados.length === 0
                                        ? <tr><td colSpan={9} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.has(row.id)}
                                                        onChange={() => toggleSelect(row.id)}
                                                    />
                                                </td>
                                                <td className="fin-pp__cell-muted" style={{ textAlign: 'right' }}>{row.codigo ?? ""}</td>
                                                <td className="fin-pp__cell-muted" style={{ textAlign: 'right' }}>{row.cargo?.nome ?? ""}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ""}</td>
                                                <td style={{ textAlign: 'right' }}>
                                                    {row.quantidadeoutroseventosparticipanteoperador ?? 0}
                                                    <span className="fin-pp__cell-muted"> / {row.quantidadeoutroseventospendentes ?? 0}</span>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{row.quantidadedesteeventoparticipanteoperador ?? 0}</td>
                                                <td className="fin-pp__cell-strong" style={{ textAlign: 'right' }}>{row.quantidadedesteeventopendentes ?? 0}</td>
                                                <td className="fin-pp__cell-muted" style={{ textAlign: 'right' }}>{row.quantidadedesteeventoconcluidos ?? 0}</td>
                                                <td>
                                                    {/* Libera os pendentes por padrão — atendimento concluído é histórico
                                                        do operador. Quando NÃO há pendentes o botão continua aparecendo e
                                                        libera os concluídos (incluirConcluidos): sem isso, o operador que
                                                        concluiu tudo por engano ficava sem nenhuma saída na tela, já que
                                                        os participantes continuam com dono e a nova vinculação os pula. */}
                                                    {row.quantidadedesteeventoparticipanteoperador > 0 ? (
                                                        <button
                                                            type="button"
                                                            className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                                                            title={row.quantidadedesteeventopendentes > 0
                                                                ? "Liberar os participantes PENDENTES deste evento vinculados ao operador"
                                                                : "Liberar os participantes CONCLUÍDOS deste evento vinculados ao operador"}
                                                            onClick={() => {
                                                                const semPendentes = !(row.quantidadedesteeventopendentes > 0);
                                                                Alert({
                                                                    icon: "error",
                                                                    confirmButton: "Sair",
                                                                    denyButton: <><FaThumbsUp size={16} /> Liberar</>,
                                                                    title: semPendentes ? "Liberar concluídos" : "Liberar pendentes",
                                                                    html: semPendentes
                                                                        ? "Este operador não tem pendentes. Serão liberados os " + row.quantidadedesteeventoconcluidos + " atendimento(s) já concluído(s), que voltam a ficar sem operador."
                                                                        : "Os atendimentos já concluídos continuam com o operador.",
                                                                    callBack: (result) => {
                                                                        if (result.isDenied) {
                                                                            api({
                                                                                method: 'delete',
                                                                                action: '/evento/desvincularParticipantesOperadores/' + id + '/' + row.id,
                                                                                token: token,
                                                                                params: semPendentes ? { incluirConcluidos: true } : {}
                                                                            })
                                                                                .then(function (response) {
                                                                                    // a lista é refeita: zera a seleção para o "marcar todos"
                                                                                    // não comparar contra um conjunto que mudou
                                                                                    setSelectedIds(new Set());
                                                                                    setOperadoresMarcados([]);
                                                                                    buscar();
                                                                                })
                                                                                .catch(function (error) {
                                                                                    //console.log(error)
                                                                                });
                                                                        }
                                                                    }
                                                                });
                                                            }}
                                                        >
                                                            <ImCancelCircle size={14} style={{ marginRight: 4 }} /> Liberar
                                                        </button>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="fin-pp__pagination">
                            <div className="fin-pp__pagination-info">{total} registros</div>
                            <div className="fin-pp__pagination-ctrls">
                                <select
                                    className="fin-pp__select"
                                    style={{ height: 34 }}
                                    value={pageSize}
                                    onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
                                >
                                    <option value={15}>15 / pág</option>
                                    <option value={30}>30 / pág</option>
                                    <option value={50}>50 / pág</option>
                                </select>
                                <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)} type="button">Anterior</button>
                                <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                                <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)} type="button">Próxima</button>
                            </div>
                        </div>
                    </div>

                    {/* Botão salvar */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                        <button
                            type="submit"
                            className="fin-pp__btn fin-pp__btn--primary"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Salvando...</>
                            ) : (
                                <><FaSave size={16} style={{ marginRight: 6 }} />Vincular</>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
